import ProductParentSelect from './ProductParentSelect'

export default ProductParentSelect
